var _a;
import { createActions, createAction } from 'redux-actions';
export var getFurnitures = (_a = createActions('GET_FURNITURES', 'RESET_FURNITURE'), _a.getFurnitures), resetFurniture = _a.resetFurniture;
export var getFurnituresComplete = createAction('GET_FURNITURES_COMPLETE', function (payload) { return payload; }, function (payload, headers) { return ({ headers: headers }); });
